import React from 'react'
import LoadingPage from './LoadingPage'
import RootRouter from '../../modules/router/RootRouter'
import AuthStatus from '../../modules/auth/AuthStatus'
import { AuthStatusEnum } from '../../modules/auth/withAuthStatus'

export default () => (
  <AuthStatus>
    {(authStatus, userId) => {
      if (authStatus === AuthStatusEnum.loading) {
        return <LoadingPage />
      }

      return <RootRouter authStatus={authStatus} userId={userId} />
    }}
  </AuthStatus>
)



// WEBPACK FOOTER //
// ./src/components/pages/RootPage.js